
import { ChangeEvent, Fragment, useMemo } from "react";
import { LabelWidthTypes } from "@enums/label-width-types";
import { ThemingFormSection } from "@containers/common/theming-form-section/theming-form-section";
import { resources } from "@constants/hardcoded-strings";
import { TextareaFormGroup } from "@containers/common/textarea-form-group/textarea-form-group";
import Alert from "react-bootstrap/Alert";
import { LayoutTypes } from "@enums/layout-types";
import styles from "@styles/common.less";

type GenericContentSlotHtmlAndCssVariablesContainerProps = {
    isDisabled: boolean;
    labelWidth: LabelWidthTypes;
    htmlTextVariables: Record<string, string>;
    updateHtmlTextVariables: (htmlTextVariables: Record<string, string>) => void;
};

export const GenericContentSlotHtmlAndCssVariablesContainer = ({ isDisabled, labelWidth, htmlTextVariables, updateHtmlTextVariables }: GenericContentSlotHtmlAndCssVariablesContainerProps) => {
    const resource = resources.pages.verificationServiceDetails.tabs.theming.subTabs.common.inputs.customHtml.sections.variables;

    const variables: Array<{ name: string; value: string; }> = useMemo(() => {
        return Object.keys(htmlTextVariables).map(key => {
            return {
                name: key,
                value: htmlTextVariables[key]
            };
        });
    }, [htmlTextVariables]);

    const handleChangeAtIndex = (event: ChangeEvent<HTMLInputElement>, index: number) => {
        updateHtmlTextVariables({
            ...htmlTextVariables,
            [variables[index].name]: event.target.value
        });
    };

    return (
        <ThemingFormSection title={resource.title}>
            <hr/>
            <div className={styles.sectionDescription}>{resource.description}</div>
            <>
                {variables.map((variable, index) => (
                    <Fragment key={`helptext-custom-htmltext-variable-${variable.name}`}>
                        <TextareaFormGroup
                            controlId={`helptext-custom-htmltext-variable-${variable.name}`}
                            automationId={`helptext-custom-htmltext-variable-${variable.name}`}
                            label={variable.name}
                            ariaLabel={variable.name}
                            isRequired={true}
                            onChange={(event: ChangeEvent<HTMLInputElement>) => handleChangeAtIndex(event, index)}
                            value={variable.value}
                            disabled={isDisabled}
                            labelWidth={labelWidth}
                            layout={LayoutTypes.COLUMN}
                        />
                    </Fragment>
                ))}
            </>
            {variables.length === 0 && (
                <Alert>{resource.noVariablesMessage}</Alert>
            )}
        </ThemingFormSection>
    );
}